import React from 'react';
import { Container, Row, Col, Button, Image } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import whatIsDmarc from '../../../../assets/img/what-is-dmarc.webp';

const WhatIsDMARCSection = ({ openModal }) => {
    const { t } = useTranslation();

    return (
        <section className="py-5 bg-white">
            <Container>
                <Row className="align-items-center justify-content-center">
                    <Col xs={12} lg={6} className="mb-4 mb-lg-0">
                        <h4 className="fw-bold mb-3">
                            {t('pages.dmarcChecker.whatIsDmarc.title')}
                        </h4>
                        <p>{t('pages.dmarcChecker.whatIsDmarc.body')}</p>
                        <div className="d-grid mt-4">
                            <Button variant="warning" size="lg" onClick={openModal}>
                                {t('pages.dmarcChecker.painPoint.bookACall')}
                            </Button>
                        </div>
                    </Col>
                    <Col xs={12} lg={6} className="d-flex justify-content-center">
                        <Image
                            src={whatIsDmarc}
                            alt={t('pages.dmarcChecker.whatIsDmarc.imageAlt') || 'What is DMARC illustration'}
                            className="img-fluid h-auto rounded"
                        />
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default WhatIsDMARCSection;
